<template lang="pug">
    v-form.c-form(autocomplete="off")
        v-container(fluid grid-list-lg)
            v-layout(raw wrap)
                v-flex(xs12)

                    // Form title
                    title-component(
                        type="h4"
                        :title="$t('managers.create.subtitle')"
                    )

                v-flex(xs12 sm6)

                    // Role selection
                    v-select.role(
                        :items="$t('selection.managers')"
                        :label="$t('fields.select_role')"
                        name="Role"
                        v-model.lazy="model.role"
                        append-icon="expand_more"
                        outline
                    )

                v-flex(xs12 sm6)

                    // Email field
                    v-text-field(
                        :error-messages="errors.collect('email')"
                        :data-vv-as="$t('fields.email')"
                        :label="$t('fields.email')"
                        name="email"
                        type="email"
                        v-model.lazy="model.email"
                        v-validate="'required|email'"
                        outline
                    )

            v-layout(raw wrap)
                v-flex(xs12 sm6)

                    // Full Name field
                    v-text-field(
                        :error-messages="errors.collect('fullName')"
                        :data-vv-as="$t('fields.fullName')"
                        :label="$t('fields.fullName')"
                        name="fullName"
                        v-model.lazy="model.fullName"
                        v-validate="'required|min:2|max:72'"
                        outline
                    )

                v-flex(xs12 sm6)

                    // Phone field
                    v-text-field(
                        :error-messages="errors.collect('phone')"
                        :data-vv-as="$t('fields.phone')"
                        :label="$t('fields.phone')"
                        name="phone"
                        v-model.lazy="model.phone"
                        v-validate="'required|min:6'"
                        mask="###-###-######-####"
                        outline
                    )

                v-flex(xs12 v-if="model.role === 'instructor'")

                    // Instructor Position
                    v-text-field(
                        name="position"
                        :label="$t('fields.position')"
                        v-model="model.position"
                        outline
                    )

                v-flex(xs12  v-if="model.role === 'instructor'")

                    // Instructor Information
                    div.mb-2 Instructor Information
                    froala(
                        v-model="model.information"
                        :tag="'textarea'"
                        :config="config"
                    )

            v-layout(raw wrap)
                v-flex(xs12)

                    // Horizontal line
                    separator-component

                    div.controls
                        div

                            // Cancel button
                            button-component.ml-0(
                                :action="cancel"
                                :isLoading="isLoading"
                                color="grey"
                                large
                                outline
                            ) {{ $t('defaultButtons.cancel') }}

                        div

                            // Submit button
                            button-component.mr-0.submit(
                                :action="submit"
                                :isLoading="isLoading"
                                color="primary"
                                large
                            ) {{ $t('defaultButtons.save') }}
</template>

<script>
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';
    import '~/plugins/froala';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            ButtonComponent: Button,
            SeparatorComponent: Separator,
            TitleComponent: Title
        },
        data() {
            return {
                config: {
                    events: {
                        'froalaEditor.initialized': function() {}
                    },
                    toolbarButtons: {
                        moreText: {
                            buttons: [
                                'bold',
                                'italic',
                                'fontSize',
                                'underline',
                                'strikeThrough',
                                'textColor',
                                'backgroundColor',
                                'subscript',
                                'superscript',
                                'fontFamily',
                                'inlineClass',
                                'inlineStyle'
                            ]
                        },
                        moreParagraph: {
                            buttons: [
                                'alignLeft',
                                'alignCenter',
                                'formatOLSimple',
                                'alignRight',
                                'alignJustify',
                                'formatOL',
                                'formatUL',
                                'paragraphFormat',
                                'paragraphStyle',
                                'lineHeight',
                                'outdent',
                                'indent',
                                'quote'
                            ]
                        },
                        moreMisc: {
                            buttons: ['undo', 'redo', 'fullscreen']
                        }
                    },
                    toolbarVisibleWithoutSelection: false,
                    quickInsertEnabled: false,
                    heightMax: 500,
                    heightMin: 300,
                    zIndex: 2501,
                    key:
                        'aLF3c1B8B7C4C2F2F2C-7gmokdhdrH-8ekB-16uD1qG-10yiB3B9B6A5C2C4F4H3A2H3=='
                }
            };
        },
        computed: {
            ...mapFields('managers', {
                model: 'manager'
            }),
            ...mapGetters('managers', ['isLoading'])
        },
        mounted() {
            this.resetManager();
            this.model.role = 'instructor';
        },
        methods: {
            ...mapActions('managers', ['create', 'resetManager', 'cancel']),

            /**
             * Create Manager account on submit
             * @returns {boolean}
             */
            async submit() {
                // Validate all fields and check in no errors
                const validation = await this.$validator.validateAll();

                if (!validation) return;

                // Call store action Create Manager account
                this.create();
            }
        }
    };
</script>
